import { render, staticRenderFns } from "./TileDataGoralLogistics.vue?vue&type=template&id=4ba53634&scoped=true"
import script from "./TileDataGoralLogistics.vue?vue&type=script&lang=js"
export * from "./TileDataGoralLogistics.vue?vue&type=script&lang=js"
import style0 from "./TileDataGoralLogistics.vue?vue&type=style&index=0&id=4ba53634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba53634",
  null
  
)

export default component.exports